import React from 'react';
import { FeedsDataItem } from '../feeds_list_types';
import FeedActionButtons from './FeedActionButtons';

const formatDate = (dateString: string): string => {
    if (!dateString) return 'Unknown';
    try {
        return new Date(dateString).toLocaleString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
    } catch {
        return dateString;
    }
};

const formatEntityList = (entities: string[]): string => {
    if (!entities || entities.length === 0) return 'Unknown';
    if (entities.length === 1) return entities[0];
    return `MULTIPLE (${entities.length})`;
};

interface FeedInformationPanelProps {
    feedItem: FeedsDataItem;
    onRefreshFeedData?: (feedId: string) => Promise<void>;
    onCloseFlyoutAndRefreshTable?: () => void;
}

const FeedInformationPanel = ({
    feedItem,
    onRefreshFeedData,
    onCloseFlyoutAndRefreshTable,
}: FeedInformationPanelProps): JSX.Element => {
    return (
        <section className="feed-info-section panel-spacing">
            <h3>Information</h3>

            <div className="info-row">
                <div className="info-group">
                    <label>Type:</label>
                    <span>{feedItem.FeedType || 'Unknown'}</span>
                </div>
                <div className="info-group">
                    <label>File Status:</label>
                    <span>{feedItem.ObjectState || 'Unknown'}</span>
                </div>
                <div className="info-group">
                    <label>Direction:</label>
                    <span>{feedItem.Direction || 'Unknown'}</span>
                </div>
                <div className="info-group">
                    <label>Verity Processed:</label>
                    <span>{formatDate(feedItem.ImportDate)}</span>
                </div>
            </div>

            <div className="info-row">
                <div className="info-group">
                    <label>Source:</label>
                    <span>{feedItem.DataSourceParter || 'Unknown'}</span>
                </div>
                <div className="info-group">
                    <label>Facility:</label>
                    <span>{formatEntityList(feedItem.CoveredEntity)}</span>
                </div>
                <div className="info-group">
                    <label>Pharmacy:</label>
                    <span>{formatEntityList(feedItem.Pharmacy)}</span>
                </div>
            </div>

            <div className="info-row">
                <div className="info-group">
                    <label>Sender Id:</label>
                    <span>{feedItem.SenderId || 'Unknown'}</span>
                </div>
                <div className="info-group">
                    <label>Receiver Id:</label>
                    <span>{feedItem.ReceiverId || 'Unknown'}</span>
                </div>
                <div className="info-group">
                    <label>Vendor Account:</label>
                    <span>{feedItem.VendorAccount || 'Unknown'}</span>
                </div>
            </div>

            <div className="info-row">
                <div className="info-group full-width">
                    <label>File Name:</label>
                    <span
                        className="filename"
                        style={{ wordBreak: 'break-all' }}
                    >
                        {feedItem.FeedName || feedItem.ShortFeedName || 'Unknown'}
                    </span>
                </div>
            </div>

            {/* Action Buttons */}
            <FeedActionButtons
                feedItem={feedItem}
                onRefreshFeedData={onRefreshFeedData}
                onCloseFlyoutAndRefreshTable={onCloseFlyoutAndRefreshTable}
            />
        </section>
    );
};

export default React.memo(FeedInformationPanel);
